module.exports = __webpack_public_path__ + "img/17876_S.a847813d.png";